import _ from 'lodash';

let validationsServiceState;

const initValidationsServiceState = () => {
    validationsServiceState = {};
};

const getCompValidationState = (compId) => _.clone(_.get(validationsServiceState, compId));

const setCompValidationState = (compId, validationState) => {
    const currentValidationState = getCompValidationState(compId);

    const newValidationState = _.assign({}, currentValidationState, validationState);

    _.set(validationsServiceState, [compId], newValidationState);
};

const unsetCompValidationState = (compId) => {
    _.unset(validationsServiceState, compId);
};

export {
    initValidationsServiceState,
    getCompValidationState,
    setCompValidationState,
    unsetCompValidationState
};
